/* unplugin-vue-components disabled */import { render } from "./ComicsContentsDetails.vue?vue&type=template&id=e2d31aea&scoped=true"
import script from "./ComicsContentsDetails.vue?vue&type=script&lang=js"
export * from "./ComicsContentsDetails.vue?vue&type=script&lang=js"

import "./ComicsContentsDetails.vue?vue&type=style&index=0&id=e2d31aea&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2d31aea"]])

export default __exports__